// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"Tabs_tabsWrapper__o+jAp","tabItem":"Tabs_tabItem__o+qvH","activeTab":"Tabs_activeTab__iFURl","inactiveTab":"Tabs_inactiveTab__Bzso+"};